<!-- start app-favourit -->
<div class="d-flex justify-content-center align-items-center pointer wrap_fav" (click)="ChangeStateFav()">
    <ng-container [ngSwitch]="state">
        <ng-container *ngSwitchCase="true">
            <img src="../../../../assets/img/favorite-3.svg" />
        </ng-container>
        <ng-container *ngSwitchDefault>
            <img src="../../../../assets/img/favorite_false.svg" />
        </ng-container>
    </ng-container>
</div>
<!-- start app-favourit -->